import { Role } from '@gm-commercial/profile-model';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { RouteParams } from '~/common/configs/route.config';
import useUrlContext from '~/common/hooks/useUrlContext';
import {
  selectActingProfileOrganization,
  selectRole,
} from '~/store/profile/profileSlice.selectors';

/** GMF organization context comes only from the matched route, never query or acting context. */
export function useOrgId(): string {
  const { organizationsId } = useParams<RouteParams>();
  const { urlContext } = useUrlContext();
  const orgFromProfile = useSelector(selectActingProfileOrganization)?.id;
  const isGmfAdvisor = useSelector(selectRole) === Role.GMF_ADVISOR;

  if (isGmfAdvisor) return organizationsId || '';
  return urlContext.organizationsId || orgFromProfile || '';
}
